import { Component } from 'react';
import { Router } from '../../configs/routes';
import cx from 'classnames';
import FundAvatar from './fundAvatar';
import styles from '../../styles/homePage/topFunds.scss';
import { Api } from '../../api';
const api = new Api();
class SuggestRelatedFunds extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      fundList: [],
    };
  }

  public async componentDidMount() {
    // filter by is hardcode as of now, can be made dynamic by passing it as prop
    const { isinCode, fundLimit } = this.props;
    const res = await api.fetchSimilarFunds(isinCode, 'BY_CATEGORY');
    if (res && res.status === 200) {
      this.setState({
        fundList: res.slice(0, fundLimit || 10),
      });
    }
  }
  private handleRowClick = (fund: any) => {
    const { slug, parentSlug, isinCode, planType = 'GROWTH' } = fund;
    const href = `/mutual-funds/${parentSlug}/${slug}/${isinCode}?ref=related-funds-mf&planType=${planType}`;
    Router.pushRoute(href, href, { shallow: true });
  };
  private renderHeader = () => {
    return (
      <li className={cx('large-12 columns', styles['list-header'])}>
        <div
          className={cx(
            'large-7 small-8 columns text--xsm',
            styles['fund-box'],
            'font--bold'
          )}
        >
          FUND
        </div>
        <div className="large-5 small-4 columns mobile-p0">
          <div className="row">
            <div className="large-6 small-6 columns text--xsm mobile-only--center font--bold">
              3YR. RTNS
            </div>
            <div className="large-6 small-6 columns text--xsm mobile-only--center font--bold">
              5YR. RTNS
            </div>
          </div>
        </div>
      </li>
    );
  };
  private renderFundList = () => {
    const { fundList } = this.state;
    return (
      <div className={cx(styles['fund-list'], 'row')}>
        {this.renderHeader()}
        {fundList.map((fundItem) => (
          <li
            key={fundItem.productId}
            className={cx('large-12 columns', styles.fundItem)}
            onClick={() => this.handleRowClick(fundItem)}
          >
            <div className={cx('large-7 small-8 columns', styles['fund-box'])}>
              <FundAvatar
                imageValign="sub"
                fundItem={{
                  fundName: fundItem.fundLegalName,
                  imageUrl: fundItem.logoImgUrl,
                  fundMetaData: {
                    parentSlug: fundItem.parentSlug,
                    slug: fundItem.slug,
                    isinCode: fundItem.isinCode,
                  },
                }}
                source={`top-funds-${fundItem.productId}`}
                className={cx(
                  'font--dark-grey font--bold text--md',
                  styles['title']
                )}
                subTitleClass="text--sm font--normal font--grey"
                width={12}
              />
            </div>
            <div className="large-5 small-4 columns mobile-p0">
              <div className="row">
                <div className="large-6 small-6 columns pt10 right-align mobile-only--center">
                  <span className="text--md">
                    {!fundItem.returns.return3yr
                      ? '--'
                      : `${fundItem.returns.return3yr}%`}
                  </span>
                </div>
                <div className="large-6 small-6 columns pt10 right-align mobile-only--center">
                  <span className="text--md">
                    {!fundItem.returns.return5yr
                      ? '--'
                      : `${fundItem.returns.return5yr}%`}
                  </span>
                </div>
              </div>
            </div>
          </li>
        ))}
      </div>
    );
  };
  public render() {
    return this.renderFundList();
  }
}

export default SuggestRelatedFunds;



// WEBPACK FOOTER //
// ./components/common/suggestRelatedFunds.tsx